import { Auth0UserRecord, MappingStringToString, UserLevel } from '@/types';
import { UserDetails } from '@/types/shared';
import { DomainCode } from '@australiangreens/ag-internal-components';

const PRINCIPAL_COORDINATOR_ROLES = [
  'State Group Admin',
  'State Officer',
  'National Officer',
  'administrator',
];

const COORDINATOR_ROLES = [
  'Local EMS Admin',
  'Local Group Admin',
  'Local Group Mail',
  'State Officer - Limited',
];

const CALLER_ROLES = ['Local EMS User', 'National EMS User', 'Statewide EMS User'];

export const userLevelPriority: UserLevel[] = [
  'Principal Coordinator',
  'Coordinator',
  'Caller',
  'None',
];

export const BUSINESS_ROLE_MAPPING: Record<UserLevel, string[]> = {
  Caller: ['Campaign Volunteer'],
  Coordinator: ['Local Organiser', 'Branch OB', 'Statewide Organiser'],
  'Principal Coordinator': [
    'Statewide Organiser',
    'State Officer',
    'National Officer',
    'Administrator',
  ],
  None: [],
};

export function determineUserLevel(
  userDetails: UserDetails,
  domainCode: DomainCode | undefined
): UserLevel {
  if (domainCode === undefined) {
    return 'None';
  }

  if (!extractRelevantDomainCodes(userDetails).includes(domainCode)) {
    return 'None';
  }

  const rolesForCurrentDomain = userDetails.rolesByDomain[domainCode];
  if (rolesForCurrentDomain === undefined) {
    return 'None';
  }
  const roleNames = rolesForCurrentDomain.map((role) => role.roleName);
  if (roleNames.some((role) => PRINCIPAL_COORDINATOR_ROLES.includes(role))) {
    return 'Principal Coordinator' as const;
  } else if (roleNames.some((role) => COORDINATOR_ROLES.includes(role))) {
    return 'Coordinator' as const;
  } else if (roleNames.some((role) => CALLER_ROLES.includes(role))) {
    return 'Caller' as const;
  }
  return 'None' as const;
}

export function mapSubToName(userRecords: Auth0UserRecord[]) {
  const resultingMap = {} as MappingStringToString;
  for (const userRecord of userRecords) {
    resultingMap[userRecord.id] = userRecord.name;
  }
  return resultingMap;
}

export function extractRelevantDomainCodes(userDetails: UserDetails) {
  return Object.keys(userDetails.rolesByDomain) as DomainCode[];
}
